import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import { coachApi } from './coachApi';
import syncReducer from './syncSlice';
import toastReducer from './toastSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    sync: syncReducer,
    toast: toastReducer,
    [coachApi.reducerPath]: coachApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(coachApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
